import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "@/lib/api";
import { useStore } from "@/context/StoreContext";
import ProductCard from "@/components/storefront/ProductCard";
import { PageHead, EmptyState } from "@/components/storefront/common";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { wishlist } = useStore();
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (wishlist.length === 0) { setProducts([]); setLoading(false); return; }
    setLoading(true);
    // fetch all active products then filter by wishlist ids (small catalog)
    api.get("/products?limit=1000").then(({ data }) => {
      setProducts(data.products.filter((p) => wishlist.includes(p.id)));
    }).finally(() => setLoading(false));
  }, [wishlist]);

  return (
    <div className="container-x py-8">
      <PageHead title="Your Wishlist" crumbs={[{ label: "Home", to: "/" }, { label: "Wishlist" }]} />
      {!loading && products.length === 0 ? (
        <EmptyState icon={Heart} title="Your wishlist is empty" text="Tap the heart on any product to save it here.">
          <Link to="/shop" className="bg-slate-900 text-white font-semibold px-6 py-3 rounded-lg">Discover Products</Link>
        </EmptyState>
      ) : (
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-6" data-testid="wishlist-grid">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
